import FJLocalStore from './FJLocalStore'
import FJViewConstant from "../constant/FJViewConstant";

const LIMIT_FREE = {
  maxDurationToExport: 60,
  maxStockVideo: 1,
  maxProjects: 12,
  hasSelfWaterMark: true,
  couldExportSizes: ['480', '720'],
};
const LIMIT_BASIC = {
  maxDurationToExport: 180,
  maxStockVideo: 1,
  maxProjects: 50,
  hasSelfWaterMark: false,
  couldExportSizes: ['480', '720'],
};
const LIMIT_PLUS = {
  maxDurationToExport: 600,
  maxStockVideo: 5,
  maxProjects: 200,
  hasSelfWaterMark: false,
  couldExportSizes: ['480', '720', '1080'],
};
const LIMIT_BUSINESS = {
  maxDurationToExport: Infinity,
  maxStockVideo: -1,
  maxProjects: 1000,
  hasSelfWaterMark: false,
  couldExportSizes: ['480', '720', '1080'],
};

function getLimits(limit, options) {
  let limits = [];
  let maxDurationLimit = FJLocalStore._('maximum-video-exceeded-intro');
  let maxStockVideoLimit = FJLocalStore._('maximum-stock-exceeded-intro');
  let customWMLimit = FJLocalStore._('custom-wm-used-intro');
  let select720Limit = FJLocalStore._('720P-download-selected-intro');
  let select1080Limit = FJLocalStore._('1080P-download-selected-intro');
  let {maxDurationToExport, maxStockVideo, hasSelfWaterMark, couldExportSizes} = limit;
  let {allDuration, numStockVideo, hasCustomWM, exportSize} = options;
  if (maxDurationToExport !== -1 && allDuration > maxDurationToExport) {
    limits.push(maxDurationLimit);
  }
  if (maxStockVideo !== -1 && numStockVideo > maxStockVideo) {
    limits.push(maxStockVideoLimit);
  }
  if (hasSelfWaterMark && hasCustomWM) {
    limits.push(customWMLimit);
  }
  if (exportSize && !couldExportSizes.includes(exportSize)) {
    switch (exportSize) {
      case FJViewConstant.RESOLUTION_720P:
        limits.push(select720Limit);
        break;
      case FJViewConstant.RESOLUTION_1080P:
        limits.push(select1080Limit);
        break;
      default:
    }
  }

  return limits;
}

let FJPaymentStore = (function () {
  let _paymentLevel = FJViewConstant.USER_PAYMENT_FREE;
  let _limits = [];
  if (window.fj && window.fj.currentPlan && window.fj.currentPlan.package) {
    switch (window.fj.currentPlan.package) {
      case 'free':
        _paymentLevel = FJViewConstant.USER_PAYMENT_FREE;
        break;
      case 'basic':
        _paymentLevel = FJViewConstant.USER_PAYMENT_BASIC;
        break;
      case 'plus':
        _paymentLevel = FJViewConstant.USER_PAYMENT_PLUS;
        break;
      case 'business':
        _paymentLevel = FJViewConstant.USER_PAYMENT_BUSINESS;
        break;
      default:
        break;
    }
  }
  return {
    getPaymentLevel: function () {
      return _paymentLevel;
    },

    setPaymentLevel: function (level) {
      _paymentLevel = level;
    },

    paymentLevelConversion: function (level) {
      switch (level) {
        case 'free':
          return FJViewConstant.USER_PAYMENT_FREE;
        case 'basic':
          return FJViewConstant.USER_PAYMENT_BASIC;
        case 'plus':
          return FJViewConstant.USER_PAYMENT_PLUS;
        case 'business':
          return FJViewConstant.USER_PAYMENT_BUSINESS;
        default:
          break;
      }
    },

    getLimits: function (level, options) {

      // options = {allDuration, numStockVideo, hasCustomWM, exportSize}
      // exportSize为可选，其他必选

      let limit = {};
      switch (level || _paymentLevel) {
        case FJViewConstant.USER_PAYMENT_FREE:
          limit = LIMIT_FREE;
          break;
        case FJViewConstant.USER_PAYMENT_BASIC:
          limit = LIMIT_BASIC;
          break;
        case FJViewConstant.USER_PAYMENT_PLUS:
          limit = LIMIT_PLUS;
          break;
        case FJViewConstant.USER_PAYMENT_BUSINESS:
          limit = LIMIT_BUSINESS;
          break;
        default:
      }

      _limits = getLimits(limit, options);
      return _limits;
    },

    isLimited: function () {
      return _limits.length !== 0;
    },
  }
})();

export default FJPaymentStore;
